<div class="login-page">
  <app-quick-text
    [title]="'Partner Portal'"
    [imgUrl]="'assets/images/login.png'"
    [index]="1"
    [backgroundColor]="'#E20074'"
    [fontColor]="'white'"
    [hasLargeHeader]="true">
    <p [innerHTML]="'rem.login_service_provider.message' | translate"></p>
    <div class="button-container">
      <scale-button [variant]="'primary'" (click)="navigateTo('/dashboard')">
        <scale-icon-action-import class="rotated-icon"></scale-icon-action-import>
        Login
      </scale-button>
      <scale-button [variant]="'primary'" (click)="navigateTo('/support')">
        <scale-icon-alert-help></scale-icon-alert-help>
        Support
      </scale-button>
    </div>
  </app-quick-text>

  <div class="content-body">
    <app-quick-text [title]="'Bitte beachten Sie folgende Hinweise: '"
      ><p></p
    ></app-quick-text>
    <app-quick-text [title]="'Zweck der Anmeldung'">
      <p>
        Der Zugang dient ausschließlich der Erfüllung vertraglich vereinbarter
        Leistungen. Jede Nutzung außerhalb dieses Rahmens ist untersagt.
      </p>
    </app-quick-text>

    <app-quick-text [title]="'Datenschutz und Sicherheit'">
      <p>
        Ihre personenbezogenen Daten werden gemäß der
        EU-Datenschutzgrundverordnung (DSGVO) und dem Bundesdatenschutzgesetz
        (BDSG) verarbeitet. <br />
        Die Datenübermittlung erfolgt verschlüsselt. Alle beteiligten
        Mitarbeitenden unterliegen der Geheimhaltungspflicht.
      </p>
    </app-quick-text>

    <app-quick-text [title]="'Verantwortlicher und Kontakt'">
      <p>
        Verantwortlich für die Datenverarbeitung ist der Auftraggeber gemäß den
        Vergabeunterlagen. <br />
        Bei Fragen wenden Sie sich bitte an den betrieblichen
        Datenschutzbeauftragten.
      </p>
    </app-quick-text>

    <app-quick-text [title]="'Nutzungsbedingungen'">
      <p>
        Der Zugang ist personengebunden und darf nicht an Dritte weitergegeben
        werden. <br />
        Änderungen an Benutzerrollen oder Zugriffsrechten müssen über den
        definierten Freigabeprozess beantragt werden.
      </p>
    </app-quick-text>

    <app-quick-text [title]="'Technische Hinweise'">
      <p>
        Für die Anmeldung benötigen Sie Ihre bereitgestellten Zugangsdaten.
        Sollten Sie Probleme beim Login haben, nutzen Sie bitte die Funktion
        "Passwort vergessen" oder wenden Sie sich an den Support.
      </p>
    </app-quick-text>

    <app-quick-text [title]="'Identität bestätigen'" *ngIf="false">
      <p>
        Falls Sie einen Aktivierungscode per Post erhalten haben und Ihre Identität
         bestätigen müssen, klicken Sie bitte <a href="/landing/identification">hier</a>.
      </p>
    </app-quick-text>
  </div>

  <a class="login-link" href="/dashboard">Hier klicken zum LOGIN</a>
</div>
